<template>
  <el-popover
    placement="left"
    @show="handleShow">
    <div class="flex-common-style">
      <span class="ml15">基础服务(customerServer)：</span>
      <el-select v-model="apiUrl" placeholder="请选择" size="mini">
        <el-option
          v-for="(item, index) in apiList"
          :key="index"
          :label="item.name + '-' + item.url"
          :value="item.url">
        </el-option>
      </el-select>
    </div>
    <div class="flex-common-style mt15">
      <span class="ml15">机器人服务(imServer)：</span>
      <el-select v-model="imUrl" placeholder="请选择" size="mini">
        <el-option
          v-for="(item, index) in imUrlList"
          :key="index"
          :label="item.name + '-' + item.url"
          :value="item.url">
        </el-option>
      </el-select>
    </div>
    <el-button class="fr mt15" size="mini" type="primary" @click="submitApiChange">切换</el-button>
    <div slot="reference" id="api-btn" v-drag v-if="isDev">切换接口</div>
  </el-popover>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  computed: {
    isDev () {
      return process.env.NODE_ENV === 'development'
    }
  },
  data () {
    return {
      apiList: [
        {
          url: 'http://10.204.42.156:9290',
          name: '谢炳卓'
        },
        {
          url: 'http://10.204.42.139:9290',
          name: '钟真元'
        },
        {
          url: 'http://10.204.42.121:9290',
          name: '于薪斌'
        },
        {
          url: 'https://test.usongshu.com/customerServer',
          name: '测试'
        }
      ],
      imUrlList: [
        {
          url: 'http://10.204.42.156:9295',
          name: '谢炳卓'
        },
        {
          url: 'http://10.204.42.139:9295',
          name: '钟真元'
        },
        {
          url: 'http://10.204.42.121:9295',
          name: '于薪斌'
        },
        {
          url: 'https://test.usongshu.com/imServer',
          name: '测试'
        }
      ],
      apiUrl: '',
      imUrl: ''
    }
  },
  methods: {
    submitApiChange () {
      Cookies.set('kf_api_url', this.apiUrl)
      Cookies.set('kf_im_url', this.imUrl)
      location.reload()
    },
    handleShow () {
      this.apiUrl = Cookies.get('kf_api_url')
      this.imUrl = Cookies.get('kf_im_url')
    }
  }
}
</script>

<style lang="less" scoped>
#api-btn{
  position: fixed;
  top: 0;
  left: calc(100% - 200px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px!important;
  background-color: #67C23A;
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
  z-index: 9999;
  font-size: 14px;
}
.store-select-radio label.el-radio{
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiSelect.vue